import React from "react";
import PropTypes from "prop-types";

import CloseButton from "./CloseButton";
import Hidden from "core/Hidden";
import {
    BannerContainer,
    BannerInnerContainer,
    BannerContent,
    PseudoLink
} from "./styles";

import { sitewideBannerTypes } from "core/props";

const DowntimeBanner = ({
    type = "downtime",
    href,
    dateString,
    longDateString,
    bannerKey,
    bannerDismiss
}) => {
    const conditionalBannerContentProps = href && {
        as: "a",
        href,
        title: "More information",
        target: "_blank"
    };

    return (
        <BannerContainer
            type={type}
            data-callback={`accounts/hide-banner/${bannerKey}`}
            data-banner-show-anonymous="true"
            data-banner-key={type}
        >
            <BannerContent {...conditionalBannerContentProps}>
                <BannerInnerContainer>
                    {/* only show on mobile devices: */}
                    <Hidden breakpoint="mdLg">
                        <PseudoLink href={href}>Scheduled Downtime</PseudoLink>:{" "}
                        {dateString}.
                    </Hidden>

                    {/* only show on tablet & desktop: */}
                    <Hidden breakpoint="sm">
                        We'll be down for{" "}
                        <PseudoLink href={href}>
                            scheduled maintenance
                        </PseudoLink>{" "}
                        on {longDateString || dateString}.
                    </Hidden>
                </BannerInnerContainer>
            </BannerContent>

            <CloseButton bannerDismiss={bannerDismiss} />
        </BannerContainer>
    );
};

DowntimeBanner.propTypes = {
    type: PropTypes.oneOf(sitewideBannerTypes),
    href: PropTypes.string,
    dateString: PropTypes.string,
    longDateString: PropTypes.string,
    bannerKey: PropTypes.any,
    bannerDismiss: PropTypes.func
};

export default DowntimeBanner;
